export default __webpack_public_path__ + "static/extensions/berry/sheeptoolkit.js";